import { CodeBlock } from '@/ui/components/ui/code-block';
import { Label } from '@/ui/components/ui/label';
import { MultiFileCodeBlock } from '@/ui/components/ui/multi-file-code-block';
import {
	Tabs,
	TabsContent,
	TabsList,
	TabsTrigger,
} from '@/ui/components/ui/tabs';
import {
	getEmbedSnippet,
	getJavaSnippet,
	getNextJsSnippet,
	getNextJsWidgetSnippet,
	getPythonSnippet,
	getTsSnippet,
} from './embed-snippets';

interface EmbedSnippetsProps {
	projectId: string;
	hmacSecret: string;
}

export function EmbedSnippets({ projectId, hmacSecret }: EmbedSnippetsProps) {
	const params = { projectId, hmacSecret };

	return (
		<div className='flex flex-col gap-4'>
			<div>
				<Label>Server-side HMAC generation</Label>
				<p className='text-xs text-muted-foreground mt-0.5'>
					Generate these values on your server before rendering the
					page — never in the browser.
				</p>
			</div>

			<Tabs defaultValue='ts'>
				<TabsList className='h-8'>
					<TabsTrigger value='ts' className='text-xs'>
						TypeScript
					</TabsTrigger>
					<TabsTrigger value='java' className='text-xs'>
						Java
					</TabsTrigger>
					<TabsTrigger value='python' className='text-xs'>
						Python
					</TabsTrigger>
				</TabsList>
				<TabsContent value='ts' className='mt-2'>
					<CodeBlock code={getTsSnippet(params)} language='ts' />
				</TabsContent>
				<TabsContent value='java' className='mt-2'>
					<CodeBlock code={getJavaSnippet(params)} language='java' />
				</TabsContent>
				<TabsContent value='python' className='mt-2'>
					<CodeBlock
						code={getPythonSnippet(params)}
						language='python'
					/>
				</TabsContent>
			</Tabs>

			<div className='flex flex-col gap-2'>
				<Label>Embed snippet</Label>
				<Tabs defaultValue='html'>
					<TabsList className='h-8'>
						<TabsTrigger value='html' className='text-xs'>
							HTML
						</TabsTrigger>
						<TabsTrigger value='nextjs' className='text-xs'>
							React.js / Next.js
						</TabsTrigger>
					</TabsList>
					<TabsContent value='html' className='mt-2'>
						<CodeBlock
							code={getEmbedSnippet({ projectId })}
							language='html'
						/>
					</TabsContent>
					<TabsContent value='nextjs' className='mt-2'>
						<MultiFileCodeBlock
							files={[
								{
									filename: 'components/feedback-widget.tsx',
									code: getNextJsWidgetSnippet(),
									language: 'ts',
								},
								{
									filename: 'app/feedback/page.tsx',
									code: getNextJsSnippet({ projectId }),
									language: 'ts',
								},
							]}
						/>
					</TabsContent>
				</Tabs>
			</div>
		</div>
	);
}
